var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7397E23D-1DCF-4E89-86D3-8375187D5977") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reviews",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case_study_no_nav",
    transform: "translate(-271.000000, -608.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Review-2",
    transform: "translate(269.000000, 519.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumb_up-24px",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L19.9201946,0 L19.9201946,18 L0,18 L0,0 Z M0,0 L19.9201946,0 L19.9201946,18 L0,18 L0,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8897064,1.545 L6.29146148,5.7 C5.98435848,5.9775 5.81005677,6.36 5.81005677,6.7575 L5.81005677,14.25 C5.81005677,15.075 6.55706407,15.75 7.47007299,15.75 L14.940146,15.75 C15.6041525,15.75 16.2017583,15.39 16.4673609,14.8425 L19.1731873,9.135 C19.8703942,7.65 18.6668824,6 16.882365,6 L12.1928191,6 L12.9813268,2.565 C13.0643277,2.19 12.9398264,1.8075 12.6410235,1.5375 C12.1513187,1.1025 11.3711111,1.1025 10.8897064,1.545 Z M2.49002433,15.75 C3.40303325,15.75 4.15004055,15.075 4.15004055,14.25 L4.15004055,8.25 C4.15004055,7.425 3.40303325,6.75 2.49002433,6.75 C1.57701541,6.75 0.83000811,7.425 0.83000811,8.25 L0.83000811,14.25 C0.83000811,15.075 1.57701541,15.75 2.49002433,15.75 Z",
    id: "Shape",
    fill: "#16A085"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.76d17c852c3ff80c1514fbd490bfe875.svg";
export { ForwardRef as ReactComponent };